import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { TOAST } from "../../../notify/toast/toast-type.enum";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { NotifyService } from "../../../notify/notify.service";
import { TierRepository } from "../../../tier/tier.repository";
import { Tier } from "../../../tier/tier.type";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-margin-select",
  templateUrl: "./margin-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class MarginSelectComponent implements OnInit {
  private notifyService = inject(NotifyService);
  private tierRepository = inject(TierRepository);

  public readonly marginChange = output<Tier[]>();
  @Input() public selectedMargin: Tier;
  public readonly placeholder = input("Users");

  public marginList: SelectItem[] = [];
  private subscription = new Subscription();

  ngOnInit() {
    this.buildMarginList();
  }

  public onChange(event) {
    this.marginChange.emit(event.value);
  }

  private buildMarginList() {
    this.marginList = [
      {
        label: "No margin",
        value: null,
      },
    ];
    this.subscription.add(
      this.tierRepository.list().subscribe({
        next: (marginList) =>
          marginList.map((margin) => {
            this.marginList.push({
              label: margin.getName(),
              value: margin,
            });
          }),
        error: (err) =>
          this.notifyService.toast(
            TOAST.ERROR,
            "Error",
            "Margin list has not been loaded",
          ),
      }),
    );
  }
}
